<template>
    <div v-click-outside="closeDropdown">
        <label class="uk-width-1-1 uk-position-relative" @click.prevent="toggleDropdown">
            <input readonly class="uk-form-small uk-input uk-width-1-1 uk-text-medium" :value="currentSelectionLabel" :placeholder="placeholderText">
            <span uk-icon="chevron-down" :class="{ 'uk-text-link uk-icon-rotate': isOpen }" class="uk-position-center-right uk-margin-xsmall-right uk-icon"></span>
        </label>
        <div class="uk-position-relative">
            <div class="uk-width-1-1 uk-dropdown uk-dropdown-scroll" v-if="isOpen" @click.stop>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
    name: "dropdown-filter",
    props: {
        filterKey: {
            type: String,
            required: true,
        },
        activeItems: {
            type: Array,
            required: true,
        },
        closeOnSelect: {
            type: Boolean,
            default: false
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            isOpen: false
        }
    },
    watch: {
        activeItems() {
            if (this.closeOnSelect) {
                this.isOpen = false;
            }
        }
    },
    computed: {
        currentSelectionLabel() {
            if (this.activeItems.length) {
                return `${this.activeItems.length} ${this.$t('message.selected')}`;
            }
            return null;
        },
        placeholderText() {
            return this.filterKey === 'departments' ? this.$t('message.all_departments') : this.$tc('message.location', 2);
        }
    },
    methods: {
        closeDropdown() {
            this.isOpen = false;
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
    }
}
</script>

<style lang="scss" scoped>
input[readonly] {
    cursor: pointer;
    background-color: #fff;
    text-transform: capitalize;
}

.uk-icon-rotate {
    transform: rotate(180deg);
}

.uk-dropdown {
    display: block;
    width: 100%;
    max-height: 250px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e5e5e5;
    padding: 10px;
    z-index: 1010;
}

.uk-position-center-right {
    top: 50%;
    transform: translateY(-50%);
}

.uk-text-link {
    color: #44bcfc !important;
}
</style> 
